module.exports = __webpack_public_path__ + "static/media/hero.fd747975.jpg";